// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circular-loader {
  width: var(--loader-size);
  height: var(--loader-size);
  display: inline-block;
  border-radius: 50%;
  background: conic-gradient(var(--loader-color) 0deg, var(--loader-color) 110deg, var(--loader-track) 110deg, var(--loader-track) 360deg);
  position: relative;
  animation: circular-loader-spin 1s linear infinite;
}

.circular-loader::after {
  content: "";
  position: absolute;
  inset: var(--loader-thickness);
  background: #ffffff;
  border-radius: 50%;
}

@keyframes circular-loader-spin {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/CircularLoader/CircularLoader.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,wIAAA;EAMA,kBAAA;EACA,kDAAA;AAJF;;AAOA;EACE,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAJF;;AAOA;EACE;IACE,yBAAA;EAJF;AACF","sourcesContent":[".circular-loader {\n  width: var(--loader-size);\n  height: var(--loader-size);\n  display: inline-block;\n  border-radius: 50%;\n  background: conic-gradient(\n    var(--loader-color) 0deg,\n    var(--loader-color) 110deg,\n    var(--loader-track) 110deg,\n    var(--loader-track) 360deg\n  );\n  position: relative;\n  animation: circular-loader-spin 1s linear infinite;\n}\n\n.circular-loader::after {\n  content: \"\";\n  position: absolute;\n  inset: var(--loader-thickness);\n  background: #ffffff;\n  border-radius: 50%;\n}\n\n@keyframes circular-loader-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
